import { Component, OnInit } from "@angular/core";
import { BindingsService } from "./bindings.service";
import { Router } from "@angular/router";
import * as moment from "moment";

@Component({
  selector: "bindings-component",
  template: require('./bindings.component.html'),
  styles: [require('./bindings.component.scss')]
})
export class BindingsComponent implements OnInit {
  bindings: any[];
  page = 0;
  itemsPerPageValues: any;
  itemsPerPage: number = 10;
  nextDisabled = false;

  constructor(private service: BindingsService, private router: Router) {
    // Do stuff

    this.itemsPerPageValues = this.service.getItemsPerPageValues();
  }

  ngOnInit() {
    this.getBindings();
  }

  getProjectName(id) {
    const result = this.service.projects.find((proj) => proj.id === id);

    if (result) {
      return result.name;
    } else {
      return "N/A";
    }
  }

  getProgramName(id) {
    const result = this.service.programs.find((prog) => prog.id === id);

    if (result) {
      return result.name;
    } else {
      return "N/A";
    }
  }

  getBindings() {
    this.service
      .getBindings({ page: this.page, limit: this.itemsPerPage })
      .subscribe((res) => {
        this.bindings = res;
        if (res.length < this.itemsPerPage) {
          this.nextDisabled = true;
        } else {
          this.nextDisabled = false;
        }
      });
  }

  pageChange(value) {
    this.page = this.page + value;
    this.getBindings();
  }

  changeItemPerPage(value) {
    this.itemsPerPage = value;
    this.page = 0;
    this.getBindings();
  }

  formatDate(date: any) {
    return moment(date).format("DD/MM/YYYY hh:mm A");
  }

  getCountryNames(ids: string[]): string[] {
    return this.service.getCountryNames(ids);
  }

  getLanguageNames(ids: string): string[] {
    return this.service.getLanguageNames([ids]);
  }

  getApp() {}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/bindings/bindings.component.ts